module.exports = __webpack_public_path__ + "static/media/ship_green.b5999078.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_green.png
// module id = 202
// module chunks = 0